import { BorderGridContainer, Button, GridBox, H2, SpacerWrapper, TypeWrapper } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';

import { CompareCoverGroup, InsuranceGroup } from '../../types';
import { FootnoteType } from '../../../../types/footnote';
import { SellingPointGroup } from '../../../../types/explained';
import InclusionsPanel from './panel';
import pageStyles from '../../styles.module.sass';
import styles from './styles.module.sass';
import TabGroupPanels from './tab-group-panels';

export type InclusionsGroup = CompareCoverGroup | InsuranceGroup | SellingPointGroup;

type InclusionsProps = {
  cta?: {
    name: string;
    url: string;
  };
  footnote?: FootnoteType;
  groups?: InclusionsGroup[];
  title: string;
};

const Inclusions = ({ cta, footnote, groups, title }: InclusionsProps) => {
  if (!groups || isEmpty(groups)) {
    return null;
  }

  const hasMultipleGroups = groups.length > 1;

  return (
    <BorderGridContainer>
      <GridBox padding="1rem">
        <div className={pageStyles.horizontalSpacingWrapper}>
          <SpacerWrapper variant={['paddingTopSpacer3', 'paddingBottomSpacer9']}>
            <TypeWrapper variant="center">
              <H2 variant={hasMultipleGroups ? 'marginBottomSpacer4' : undefined}>{title}</H2>
            </TypeWrapper>
            {hasMultipleGroups ? (
              <TabGroupPanels groups={groups} footnote={footnote} />
            ) : (
              <InclusionsPanel {...groups[0]} isPortableTextDescription />
            )}
          </SpacerWrapper>
          {cta && (
            <SpacerWrapper variant={[styles.cta, 'paddingBottomSpacer8']}>
              <Button to={cta.url}>{cta.name}</Button>
            </SpacerWrapper>
          )}
        </div>
      </GridBox>
    </BorderGridContainer>
  );
};

export default Inclusions;
